import Vue from "vue";
import Vuex from "vuex";
import Cookie from "js-cookie";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userAvatar: "",
    userName: "",
    theme: ""
  },
  mutations: {
    getUserAvatar(state, userAvatar) {
      state.userAvatar = userAvatar;
    },
    getUserName(state, userName) {
      state.userName = userName;
    },
    setTheme(state, str) {
      Object.assign(state, { theme: str });
    }
  },
  actions: {
    logout() {
      const DOMAIN = process.env.VUE_APP_DOMAIN;
      Cookie.remove("token", { domain: DOMAIN });
      Cookie.remove("_vip_token", { domain: DOMAIN });
      Cookie.remove("avatar", { domain: DOMAIN });
      Cookie.remove("nickname", { domain: DOMAIN });
      Cookie.remove("uid", { domain: DOMAIN });
      Cookie.remove("uname", { domain: DOMAIN });
      const referer = window.location.href;
      const PASSPORT_PREFIX = "https://passport" + DOMAIN;
      window.location.href = PASSPORT_PREFIX + "/?referer=" + referer;
    },
    setTheme({ commit }, str) {
      localStorage.setItem("theme", str);
      commit("setTheme", str);
    }
  },
  modules: {},
  getters: {
    theme: state => state.theme
  }
});
